import { Banner, LoadingSpinner, Typography } from '@neo4j-ndl/react';
import { useConnection, useCurrentGuide } from '@nx/state';
import { GUIDES_HTML_TAGS, JsonUiConverter } from '@nx/ui';

const DATABASE_URI_PATTERN = '{neo4j-database-uri}';

const jsonUiConverter = new JsonUiConverter();

const Content = () => {
  const { guide, fetchStatus } = useCurrentGuide();
  const connection = useConnection();

  if (guide === undefined) {
    switch (fetchStatus) {
      case 'loading':
        return <LoadingSpinner size="large" />;
      case 'error':
        return (
          <Banner type="danger" title="Could not load guide" description={<p>Try again later.</p>} usage="inline" />
        );
      default:
        return null;
    }
  }

  const contents = guide.contents.map((page) =>
    jsonUiConverter.replaceTextNode(
      page,
      DATABASE_URI_PATTERN,
      connection.metadata?.url ?? 'neo4j+s://xxx.databases.neo4j.io',
    ),
  );

  return (
    <div className="bg-neutral-bg-weak rounded-1xl flex flex-col gap-12 p-6">
      {contents.map((page, index) => {
        return (
          <div key={index} className="flex flex-col gap-4">
            <h6>
              {index + 1}. {jsonUiConverter.getTitleFromDomJsonByTagName(page, GUIDES_HTML_TAGS.H2)}
            </h6>
            <Typography variant="body-medium" as="div" className="tracking-normal">
              {jsonUiConverter.renderDomJson2Jsx(page)}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default Content;
